import actionTypes from './actionTypes'

const nickelTourActions = {

	initialize: () => ({
		type: actionTypes.NICKEL_TOUR_INITIALIZE,
	}),

	close: step => ({
		type: actionTypes.NICKEL_TOUR_CLOSE,
		step,
	}),

	complete: timeSpent => ({
		type: actionTypes.NICKEL_TOUR_COMPLETED,
		timeSpent,
	}),

	notificationCloseFailed: error => ({
		type: actionTypes.NICKEL_TOUR_NOTIFICATION_CLOSE_FAILED,
		error,
	}),

	notificationCompleteFailed: error => ({
		type: actionTypes.NICKEL_TOUR_NOTIFICATION_COMPLETE_FAILED,
		error,
	}),
}

export default nickelTourActions
